export const MINIMUM_SOL_BALANCE_LAMPORTS = 8000000n; // 0.008 SOL
export const SOL_DECIMALS = 9;
// rent for an account with 165 bytes of data
export const TOKEN_ACCOUNT_RENT = 2039280n;
// rent for an account with 0 bytes of data
export const NATIVE_SOL_ACCOUNT_RENT = 890880n;
export const SOL_TRANSACTION_FEE = 5000n;
